<script setup>
const emit = defineEmits(['select'])
const props = defineProps({
  list: Array,
  key_field: String,
  title_field: Array,
  placeholder: String,
  multiple: Boolean,
  showSelectedTitle: {
    type: Boolean,
    default: true
  },
  disabled: {
    type: Boolean,
    default: false
  }
})
const openDropdown = ref(false)
const selectedTitle = ref('')
function handleSelect(item) {
  selectedTitle.value = props.title_field.map(field => {
    if (field === 'company_short_name' && item[field]) {
      return `<span class="text-accent font-semibold">${item[field]}</span>`;
    } else {
      return item[field];
    }
  }).join(' ')
  emit('select', item)
  if (!props.multiple) {
    openDropdown.value = false
  }
}

</script>

<template>
  <div>
    <div v-if="openDropdown" @click="openDropdown = false" class="fixed top-0 left-0 w-full h-full z-[5]"></div>
    <button
        type="button"
        @click="openDropdown = !openDropdown"
        class="input-decorator text-left w-full bg-secondary relative px-3 py-1 z-[5]"
        :class="disabled ? 'cursor-not-allowed bg-secondary-500 pointer-events-none' : 'cursor-pointer'"
    >
      <p class="p-1.5 flex justify-between items-center pr-2.5">
        <span v-if="selectedTitle && showSelectedTitle" v-html="selectedTitle" class="whitespace-nowrap overflow-hidden overflow-ellipsis"></span>
        <span v-else class="whitespace-nowrap overflow-hidden overflow-ellipsis">{{ placeholder }}</span>
        <IconUIChevronUp class="transition-all duration-150 ease-in" :class="{ 'flip': !openDropdown }"/>
      </p>

      <div v-if="list.length" :class="{ 'h-0' : !openDropdown, 'h-fit border' : openDropdown }" class="transition-all duration-100 ease-in absolute left-0 top-[50px] bg-white max-h-[200px] overflow-y-scroll z-10 border-light rounded-md max-w-full w-full">
        <div v-for="item in list" :key="item[key_field]" @click.stop.prevent="handleSelect(item)" class="p-2 border-t border-light overflow-hidden overflow-ellipsis">
          <template v-for="field in title_field">
            <span v-if="item[field]" :class="{ 'text-accent font-semibold' : field === 'company_short_name' }">{{ item[field] }} {{}}</span>
          </template>
        </div>
      </div>
    </button>
  </div>
</template>

<style scoped>

</style>